import React, { ReactNode, useMemo } from "react";

import { useEventListener } from "@hooks/event";

import GLOBAL_EVENT from "@utils/enums/event";

import t from "@assets/text";

import { SessionExpire } from "../../../components/ToastMessage";

import AuthContext from "./auth-context";

interface Props {
  children: ReactNode;
}

function AuthProvider({ children }: Props) {
  useEventListener(
    GLOBAL_EVENT.AUTH.VALIDATE_SESSION,
    () => {
      SessionExpire(t("toasts.authorization"));

      sessionStorage.clear();
      setTimeout(() => {
        const newUrl = `${window.location.origin}/login`;
        window.history.pushState({}, "", newUrl);
        location.reload();
      }, 1000);
    },
    []
  );

  const memoizedValue = useMemo(() => ({}), []);

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
